import React from "react";
import { cn } from "@gettactic/helpers/src/css/cn";
import { useDataMan } from "../../hooks/useDataMan";
import { DataManColumnProvider } from "../../providers/DataManColumnProvider";

interface DataManTableViewHierarchyHeaderProps {
  className?: string;
}

export const DataManTableViewHierarchyHeader = React.forwardRef<
  HTMLTableSectionElement,
  DataManTableViewHierarchyHeaderProps
>(({ className }, ref) => {
  const {
    viewModeOptions,
    visibleHierarchyColumns,
    hasHierarchyActions,
    hasSortableDataColumns
  } = useDataMan();
  return (
    <thead className={cn("relative z-[10] bg-[#F7F9FB] border-y border-[rgba(20,29,38,0.05)]", className)} ref={ref}>
      <tr>
        {hasSortableDataColumns && (
          <DataManColumnProvider isSortableHandler>
            {React.createElement(viewModeOptions.ColumnTitle)}
          </DataManColumnProvider>
        )}
        {(visibleHierarchyColumns || []).map((column) => (
          <DataManColumnProvider column={column} key={column.key}>
            {React.createElement(viewModeOptions.HierarchyColumnTitle)}
          </DataManColumnProvider>
        ))}
        {hasHierarchyActions && (
          <DataManColumnProvider isOptionsColumn isActionColumn>
            {React.createElement(viewModeOptions.ColumnTitle)}
          </DataManColumnProvider>
        )}
      </tr>
    </thead>
  );
});
